import {DeleteRecordsConfirmationButton,} from '@flexinet/ui-components';

import {useParams} from 'react-router-dom';

import {useNotificationSubscriptions} from '../hooks/useNotificationSubscriptions.ts';
import {useNotificationSubscriptionsSelection} from "../hooks/useNotificationSubscriptionsSelection.ts";

export const DeleteRecordButton = () => {
    const {id: productId} = useParams()

    if (!productId) {
        throw new Error('productId is required parameter')
    }

    const {deleteRecords} = useNotificationSubscriptions(productId);

    const {
        selection,
        handleClearSelection,
    } = useNotificationSubscriptionsSelection();

    const recordIds = Object.keys(selection);
    let disabled = true;
    if (recordIds.length > 0) {
        disabled = false;
    }


    return (<DeleteRecordsConfirmationButton
        disabled={disabled}
        recordIdsLength={recordIds.length}
        handleConfirm={() => {
            deleteRecords()
            handleClearSelection()
        }}/>);
};
